import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-primary-50/60">
      <div className="container-page grid gap-8 py-12 md:grid-cols-4 md:gap-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-emotion-happy-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              喵趣<span className="text-primary-600">漫画</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-6 text-foreground-700">
            喵趣漫画网专注萌系日常题材，收录治愈番、搞笑萌漫、软萌画风、温馨向轻喜剧等轻松作品。不用费脑，点开就开心，适合碎片时间放松。
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {categories.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`} className="chip hover:bg-secondary-200">
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        <nav aria-label="网站导航">
          <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/" className="text-foreground-700 transition-colors hover:text-primary-700">首页</Link></li>
            <li><Link to="/category/all" className="text-foreground-700 transition-colors hover:text-primary-700">全部作品</Link></li>
            <li><Link to="/about" className="text-foreground-700 transition-colors hover:text-primary-700">关于我们</Link></li>
            <li><Link to="/faq" className="text-foreground-700 transition-colors hover:text-primary-700">常见问题</Link></li>
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-foreground-700">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
              hello@miaoqu-comics.example.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-600" aria-hidden="true"></i>
              每周一至周五 10:00 - 18:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-question-line text-primary-600" aria-hidden="true"></i>
              投稿 / 合作欢迎来信
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 喵趣漫画网 · 萌系日常与治愈番合集，温暖每一段碎片时光。</p>
          <p className="flex items-center gap-2">
            <i className="ri-heart-3-fill text-accent-500" aria-hidden="true"></i>
            用心收录每一部治愈之作
          </p>
        </div>
      </div>
    </footer>
  );
}